export default __webpack_public_path__ + "images/8b87213761a6fe914e0a07d4131b006f.png";